import { DpdProductFull } from "@/model/new-parcel-model/dpd-product/dpd-product-full"
import _ from "lodash"

function convertServiceCodeToTextCode(allProducts: DpdProductFull[], serviceCode: string): string[] {
  const serviceTextCode = []
  allProducts.map(product => {
    product.dpdProductVariants.map(variant => {
      if (variant.serviceCode.toString() === serviceCode) {
        serviceTextCode.push(variant.serviceTextCode)
      }
    })
  })

  return _.uniq(serviceTextCode)
}

function convertTextCodeToServiceCode(allProducts: DpdProductFull[], serviceTextCode: string): string {
  let serviceCode = ""

  allProducts.map(product => {
    product.dpdProductVariants.map(variant => {
      if (variant.serviceTextCode === serviceTextCode) {
        serviceCode = variant.serviceCode.toString()
      }
    })
  })
  return serviceCode
}

export { convertServiceCodeToTextCode, convertTextCodeToServiceCode }
